// initial state
import * as base from './base.js'
const baseName = '/admin/commodity'
const baseNameType = '/admin/commodityType'


const commodityList = baseName + '/list'
const commodityAdd = baseName + '/add'
const commodityEdit = baseName + '/edit'
const commodityDelete = baseName + '/delete'
const commodityTypeList = baseNameType + '/list'


const obj = base.setBaseUrl('commodity', baseName)
const obj1 = base.setBaseUrl('commodityList', commodityList)
const obj2 = base.setBaseUrl('commodityAdd', commodityAdd)
const obj3 = base.setBaseUrl('commodityEdit', commodityEdit)
const obj6 = base.setBaseUrl('commodityDelete', commodityDelete)
const obj4 = base.setBaseUrl('commodityType', baseNameType)
const obj5 = base.setBaseUrl('commodityTypeList', commodityTypeList)

const a = Object.assign(obj, obj1, obj2, obj3,obj4, obj5,obj6,{ commodityList, commodityAdd,commodityEdit,commodityDelete,baseNameType, commodityTypeList})
export default a
